const prizesMap = {
  // 获取我的奖品列表
  getMyPrizesList: '/usb/uwb-app/api/v1/takeFree/reward/myList',
};

export default prizesMap;
